import Vue from 'vue'
import App from './App.vue'

import router from '@/router'

//elementUI组件库
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

Vue.use(ElementUI)

//WoW.js
import 'animate.css'
import 'wowjs/css/libs/animate.css'

//iconSymbol 图标
import '@/styles/icons/iconfont.js'

Vue.config.productionTip = false


const vue = new Vue({
    render: h => h(App),
    router,
    beforeCreate() {
        Vue.prototype.$bus = this

    }
})


vue.$mount('#app')



